import type { AnalyticsWorkbookSheets } from "./runReport";

// SheetJS is loaded on demand (dynamic import → its own chunk), so the ~400 KB
// library costs nothing until someone actually downloads a report.

type Xlsx = typeof import("xlsx");

export const toWorkbook = (
  XLSX: Xlsx,
  sheets: AnalyticsWorkbookSheets,
): ReturnType<Xlsx["utils"]["book_new"]> => {
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(
    workbook,
    XLSX.utils.aoa_to_sheet(sheets.config),
    "config",
  );
  XLSX.utils.book_append_sheet(
    workbook,
    XLSX.utils.aoa_to_sheet(sheets.report),
    "report",
  );
  return workbook;
};

export const downloadXlsx = async (
  sheets: AnalyticsWorkbookSheets,
  fileName: string,
): Promise<void> => {
  const XLSX = await import("xlsx");
  XLSX.writeFile(toWorkbook(XLSX, sheets), fileName);
};
